<template>
    <q-page class="q-pa-lg">

        <!-- SECCIÓN: DATOS DE LA EMPRESA -->
        <div class="cfg-header q-mb-lg">
            <div>
                <div class="cfg-title">Configuración</div>
                <div class="cfg-sub">Datos generales de la empresa</div>
            </div>
            <div class="row q-gutter-sm">
                <q-btn unelevated color="negative" icon="mdi-image-off" label="Eliminar Logo"
                    style="border-radius:10px" @click="eliminarLogo()" />
                <q-btn unelevated color="primary" icon="mdi-content-save" label="Guardar"
                    style="border-radius:10px" @click="guardarOactualizar()" />
            </div>
        </div>

        <div class="row q-col-gutter-lg q-mb-lg">

            <!-- COLUMNA IZQUIERDA — FORMULARIO -->
            <div class="col-12 col-md-7">

                <!-- CARD: DATOS FISCALES -->
                <div class="cfg-card q-mb-md">
                    <div class="cfg-card-title">
                        <q-icon name="mdi-domain" size="18px" color="primary" class="q-mr-sm" />
                        Datos Fiscales
                    </div>
                    <div class="row q-col-gutter-sm">
                        <div class="col-12 col-md-6">
                            <q-input dense filled v-model="empresa.rfc" label="RFC" />
                        </div>
                        <div class="col-12 col-md-6">
                            <q-input dense filled v-model="empresa.domicilioFiscal" label="Código Postal" />
                        </div>
                        <div class="col-12">
                            <q-input dense filled v-model="empresa.nombre" label="Nombre o Razón Social" />
                        </div>
                        <div class="col-12" v-if="ValidaRegimen !== ''">
                            <q-select dense filled v-model="empresa.regimenFiscal"
                                :options="regimenFiscal" label="Régimen Fiscal"
                                option-label="regimenFiscal" />
                        </div>
                    </div>
                </div>

                <!-- CARD: LOGO Y COLOR -->
                <div class="cfg-card q-mb-md">
                    <div class="cfg-card-title">
                        <q-icon name="mdi-palette" size="18px" color="primary" class="q-mr-sm" />
                        Identidad Visual
                    </div>
                    <div class="row q-col-gutter-sm">
                        <div class="col-12">
                            <div class="upload-label">Logo de la empresa (.jpg, .jpeg, .png)</div>
                            <q-input filled dense type="file" accept=".jpg,.jpeg,.png" @input="uploadImage" />
                        </div>
                        <div class="col-12">
                            <div class="upload-label">Color de los reportes</div>
                            <q-input dense filled v-model="empresa.color" :rules="['anyColor']" class="my-input">
                                <template v-slot:append>
                                    <q-icon name="colorize" class="cursor-pointer">
                                        <q-popup-proxy transition-show="scale" transition-hide="scale">
                                            <q-color v-model="empresa.color" />
                                        </q-popup-proxy>
                                    </q-icon>
                                </template>
                            </q-input>
                        </div>
                    </div>
                </div>

                <!-- CARD: CONFIGURACIÓN DE CORREO -->
                <div class="cfg-card">
                    <div class="cfg-card-title">
                        <q-icon name="mdi-email-outline" size="18px" color="primary" class="q-mr-sm" />
                        Correo Electrónico
                    </div>
                    <div class="row q-col-gutter-sm">
                        <div class="col-12 col-md-6">
                            <q-input dense filled v-model="empresa.nombreCorreo" label="Nombre del emisor" />
                        </div>
                        <div class="col-12 col-md-6">
                            <q-input dense filled v-model="empresa.correo" label="Correo electrónico" />
                        </div>
                        <div class="col-12 col-md-4">
                            <q-input dense filled v-model="empresa.password" label="Contraseña"
                                :type="isPwd ? 'password' : 'text'">
                                <template v-slot:append>
                                    <q-icon :name="isPwd ? 'visibility_off' : 'visibility'"
                                        class="cursor-pointer" @click="isPwd = !isPwd" />
                                </template>
                            </q-input>
                        </div>
                        <div class="col-12 col-md-4">
                            <q-input dense filled v-model="empresa.puerto" label="Puerto" />
                        </div>
                        <div class="col-12 col-md-4">
                            <q-input dense filled v-model="empresa.host" label="Host" />
                        </div>
                    </div>
                </div>

            </div>

            <!-- COLUMNA DERECHA — PREVIEW LOGO -->
            <div class="col-12 col-md-5">
                <div class="cfg-card logo-preview-card">
                    <div class="cfg-card-title">
                        <q-icon name="mdi-image-outline" size="18px" color="primary" class="q-mr-sm" />
                        Vista previa del logo
                    </div>
                    <div class="logo-preview-wrap">
                        <q-img
                            :src="empresa.logo.base64"
                            class="logo-preview-img"
                            fit="contain"
                        >
                            <template v-slot:error>
                                <div class="logo-placeholder">
                                    <q-icon name="mdi-image-off-outline" size="48px" color="grey-4" />
                                    <div class="text-grey-5 q-mt-sm text-caption">Sin logo cargado</div>
                                </div>
                            </template>
                        </q-img>
                    </div>
                    <!-- COLOR PREVIEW -->
                    <div class="color-preview-wrap q-mt-md" v-if="empresa.color">
                        <div class="color-preview-label">Color de reportes</div>
                        <div class="color-preview-bar" :style="{ background: empresa.color }"></div>
                        <div class="color-preview-hex">{{ empresa.color }}</div>
                    </div>
                </div>
            </div>

        </div>
    </q-page>
</template>

<script>
import axios from 'axios'
import { resizeImagePixels } from '../../plugins/rezizeImage.js'
import blancoImage from '../../assets/blanco.png'
import { QSpinnerCube } from 'quasar'

export default {
    data() {
        return {
            isPwd: true,
            regimenFiscal: []
        }
    },

    computed: {
        empresa() {
            return this.$store.state.empresaStore
        },
        token() {
            return this.$store.state.usuario
        },
        regimenFiscalDefault() {
            return this.$store.state.regimenFiscalStore
        },
        ValidaRegimen() {
            const rfc = this.$store.state.empresaStore.rfc
            if (rfc.length === 12) {
                this.regimenFiscal = this.$store.state.regimenFiscalStore.filter(f => f.moral === 'Sí')
                return 'M'
            } else if (rfc.length === 13) {
                this.regimenFiscal = this.$store.state.regimenFiscalStore.filter(f => f.fisica === 'Sí')
                if (rfc === 'XAXX010101000' || rfc === 'XEXX010101000') {
                    const b = this.regimenFiscal.find(f => f.clave === '616')
                    this.$store.state.empresaStore.regimenFiscalReceptor = b
                }
                return 'F'
            }
            return ''
        }
    },

    created() {
        this.GetRegimenFiscal()
        this.GetEmpresa()
    },

    methods: {
        async GetRegimenFiscal() {
            if (this.$store.state.regimenFiscalStore.length === 0) {
                try {
                    const { data } = await axios.get('https://api-beta-erp.contago.com.mx/api/CatalogosSat/GetCatRegimenFiscalAsync/')
                    this.$store.state.regimenFiscalStore = data
                } catch (error) {
                    console.log(error)
                }
            }
        },

        guardarOactualizar() {
            if (!this.empresa._id || this.empresa._id === '0') {
                this.PostEmpresa()
            } else {
                this.PutEmpresa()
            }
        },

        async PostEmpresa() {
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'primary', spinnerSize: 140, message: 'Guardando información...', messageColor: 'white' })
            try {
                await axios.post('Empresa/PostEmpresa/erp_' + this.token.rfc, this.empresa)
                this.$q.notify({ type: 'positive', message: 'Configuración guardada exitosamente.' })
            } catch (error) {
                console.log(error)
                this.$q.notify({ type: 'negative', message: 'Error al guardar, verifique la información e intente de nuevo.' })
            } finally {
                this.$q.loading.hide()
            }
        },

        async PutEmpresa() {
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'primary', spinnerSize: 140, message: 'Guardando información...', messageColor: 'white' })
            try {
                await axios.put('Empresa/PutEmpresa/erp_' + this.token.rfc, this.empresa)
                this.$q.notify({ type: 'positive', message: 'Configuración guardada exitosamente.' })
            } catch (error) {
                console.log(error)
                this.$q.notify({ type: 'negative', message: 'Error al guardar, verifique la información e intente de nuevo.' })
            } finally {
                this.$q.loading.hide()
            }
        },

        async GetEmpresa() {
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'primary', spinnerSize: 140, message: 'Cargando datos de la empresa...', messageColor: 'white' })
            try {
                const { data } = await axios.get('Empresa/GetEmpresa/erp_' + this.token.rfc + '/' + this.token.rfc)
                this.$store.state.empresaStore = { ...data }
            } catch (error) {
                console.log(error)
                this.$store.state.empresaStore = {
                    _id: '', rfc: '', nombre: '',
                    regimenFiscal: null, domicilioFiscal: '',
                    logo: { base64: '' },
                    correo: '', password: '', nombreCorreo: '',
                    host: '', puerto: '', noCre: ''
                }
            } finally {
                this.$q.loading.hide()
            }
        },

        eliminarLogo() {
            this.rutaToBase64(blancoImage)
        },

        rutaToBase64(imagePath) {
            const img = new Image()
            img.src = imagePath
            img.onload = () => {
                const canvas = document.createElement('canvas')
                canvas.width  = img.width
                canvas.height = img.height
                canvas.getContext('2d').drawImage(img, 0, 0)
                this.$store.state.empresaStore.logo.base64 = canvas.toDataURL('image/png')
            }
        },

        convertBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload  = () => resolve(reader.result)
                reader.onerror = () => reject(reader.error)
            })
        },

        async uploadImage(event) {
            const file = event[0]
            try {
                const resized = await resizeImagePixels(file, 600, 400)
                this.$store.state.empresaStore.logo.base64 = resized
            } catch (error) {
                console.error(error)
            }
        }
    }
}
</script>

<style scoped>
.cfg-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
}

.cfg-title {
    font-size: 22px;
    font-weight: 600;
    color: #1a1a2e;
}

.cfg-sub {
    font-size: 13px;
    color: #aaa;
    margin-top: 2px;
}

.cfg-card {
    background: #fff;
    border: 0.5px solid #e3e3e3;
    border-radius: 16px;
    padding: 20px;
}

.cfg-card-title {
    font-size: 13px;
    font-weight: 600;
    color: #555;
    text-transform: uppercase;
    letter-spacing: .06em;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
}

.upload-label {
    font-size: 11px;
    color: #888;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: .05em;
    font-weight: 600;
}

/* Logo preview */
.logo-preview-card {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.logo-preview-wrap {
    flex: 1;
    border: 0.5px dashed #ddd;
    border-radius: 12px;
    overflow: hidden;
    min-height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafafa;
}

.logo-preview-img {
    width: 100%;
    max-height: 260px;
}

.logo-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 40px;
}

/* Color preview */
.color-preview-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
}

.color-preview-label {
    font-size: 11px;
    color: #aaa;
    text-transform: uppercase;
    letter-spacing: .05em;
    font-weight: 600;
    white-space: nowrap;
}

.color-preview-bar {
    flex: 1;
    height: 24px;
    border-radius: 8px;
    border: 0.5px solid #e3e3e3;
}

.color-preview-hex {
    font-size: 12px;
    color: #555;
    font-family: 'Courier New', monospace;
    white-space: nowrap;
}
</style>